export interface IEntosSxediou {
    id?: number;
    eidos_metavolis: string;
    atak: string;
    a_a: number;
    nomos: string;
    dimotiko_diamerisma: string;
    dimos_koinotita: string;
    odos_arithmos: string;
    p: string;
    odos: string;
    p_1: string;
    odos_1: string;
    p_2: string;
    odos_2: string;
    p_3: string;
    plithos_prosopsewn: string;
    arithmos_oikodom_tetragwnou: string;
    katigoria_akinitou: string;
    eidikwn_sinthikwn: string;
    orofos: string;
    ktisma_epifaneia_kurioi_xwroi: number;
    ktisma_epifaneia_voithit_xwroi: number;
    ktisma_etos_kataskeuhs: string;
    ktisma_eidos_emp_dikaiomatos: string;
    ktisma_pososto_sinidiokt: string;
    ktisma_etos_gen_epikarp: string;
    epifaneia_oikopedo: number;
    oikopedo_eidos_emp_dikaiom: string;
    oikopedo_pososto_sunid: string;
    oikopedo_etos_gen_epikarp: string;
    sunoliki_epifa_ktisma: number;
    kwdikos_arithmos_idiokt: string;
    tk: string;
    kaek_kwd_akinitou: string;
    mikos_prosopsis_ktism: number;
    mikos_prosopsis_oikop: number;
    arithmos_paroxis_reum: string;
    aitia_eisagwghs_ktism_oikop: string;
    arithmos_sumvol: number;
    imerominia_sumvol: string;
    afm_sumvol: string;
    titlos_ktisis: string;
    arithmos_oikodom_adeias: string;
    afm_apoviwsanta: string;
    imerominia_thanatou: string;
    arithmos_diathikis: string;
    imerominia_dimosieushs_diathikis: string;
    arithmos_apofasis: string;
    dikastiki_arxi: string;
    arithmos_ekthesis: string;
    imerominia_ekthesis: string;
    epikarpwths_ktisma: string;
    epikarpwths_oikopedo: string;
    arithmos_ergotaksiakis_paroxis: string;
    eidiki_katigoria: string;
    xrisi_ktism_oikopedou: string;
    aitia_metavolis_stoixeiwn_ktism: string;
    arithmos_protokolou_katedafisis: string;
    afm_bipe_epix_parkou: string;
    arithmos_apofasis_vevaiwshs_fek: string;
    imerominia_apofasis: string;
    ipiresia_ekdosis_apofasis: string;
    afm_ipiresias: string;
    nomos_fek: string;
    imerominia_fek: string;
    poso_enfia: string;
    kadik: string;
}
export class EntosSxediouModel implements IEntosSxediou {
    id?: number;
    eidos_metavolis: string;
    atak: string;
    a_a: number;
    nomos: string;
    dimotiko_diamerisma: string;
    dimos_koinotita: string;
    odos_arithmos: string;
    p: string;
    odos: string;
    p_1: string;
    odos_1: string;
    p_2: string;
    odos_2: string;
    p_3: string;
    plithos_prosopsewn: string;
    arithmos_oikodom_tetragwnou: string;
    katigoria_akinitou: string;
    eidikwn_sinthikwn: string;
    orofos: string;
    ktisma_epifaneia_kurioi_xwroi: number;
    ktisma_epifaneia_voithit_xwroi: number;
    ktisma_etos_kataskeuhs: string;
    ktisma_eidos_emp_dikaiomatos: string;
    ktisma_pososto_sinidiokt: string;
    ktisma_etos_gen_epikarp: string;
    epifaneia_oikopedo: number;
    oikopedo_eidos_emp_dikaiom: string;
    oikopedo_pososto_sunid: string;
    oikopedo_etos_gen_epikarp: string;
    sunoliki_epifa_ktisma: number;
    kwdikos_arithmos_idiokt: string;
    tk: string;
    kaek_kwd_akinitou: string;
    mikos_prosopsis_ktism: number;
    mikos_prosopsis_oikop: number;
    arithmos_paroxis_reum: string;
    aitia_eisagwghs_ktism_oikop: string;
    arithmos_sumvol: number;
    imerominia_sumvol: string;
    afm_sumvol: string;
    titlos_ktisis: string;
    arithmos_oikodom_adeias: string;
    afm_apoviwsanta: string;
    imerominia_thanatou: string;
    arithmos_diathikis: string;
    imerominia_dimosieushs_diathikis: string;
    arithmos_apofasis: string;
    dikastiki_arxi: string;
    arithmos_ekthesis: string;
    imerominia_ekthesis: string;
    epikarpwths_ktisma: string;
    epikarpwths_oikopedo: string;
    arithmos_ergotaksiakis_paroxis: string;
    eidiki_katigoria: string;
    xrisi_ktism_oikopedou: string;
    aitia_metavolis_stoixeiwn_ktism: string;
    arithmos_protokolou_katedafisis: string;
    afm_bipe_epix_parkou: string;
    arithmos_apofasis_vevaiwshs_fek: string;
    imerominia_apofasis: string;
    ipiresia_ekdosis_apofasis: string;
    afm_ipiresias: string;
    nomos_fek: string;
    imerominia_fek: string;
    poso_enfia: string;
    kadik: string;

    constructor(value?: IEntosSxediou) {
        if (value) Object.assign(this, value);
    }

}
